/**
* ACMSWidget -- multi-select widget with autocomplete
*
* NOTE: this widget is terrible. Only messages [newMessage.js]
* (which are also terrible) should use it. And only because we
* are just leaving messages alone until something prompts us to
* redo them. Consider this deprecated.
*
*
* EXPECTS the following as properties of argument
* - availableItems: array of available items, in one of two formats:
*      Format 'availableItemsHasId true': [ {'id': id1, 'value': value1}, {'id': id2, 'value': value2}, ... ]
*      Format 'availableItemsHasId false': [ value1, value2, value3, ... ]
* - availableItemsHasId: boolean indicates format of availableItems array and externally selected items
*      Defaults to FALSE
* - inputContainer: jQuery container for holding input field -- **this will be emptied and rebuilt**
* - selectedContainer: jQuery container for displaying selected items -- **this will be emptied and rebuilt**
* - selectedClasses: array of classes to apply to selected items.
*      Defaults to "fieldSaved"
* - selectedContainerClasses: array of classes to apply to selectedContainer when at least one item is selected
*      Defaults to "fieldSaved"
* - selectedListType: either "ordered" or "unordered"
*      If undefined, defaults to selected items being bracketed in <div> tags
* - listClasses: if selectedListType is "ordered" or "unordered", classes to apply to <ol> or <ul> tag.
*      Defaults to "fieldSavedBullet"
* - selectSaveFn: save function called when item is selected
*      Allows for direct saving of item when selectItem is called
*      Expected to return a model with a getId() property
* - selectAltSaveFn: alternative save function to call when item is selected instead of selectSaveFn
*      Allows for alternate behavior when selectItem is called externally
*      Same properties as selectSaveFn
* - hasSelectedFn: function to call when selecting item if at least one item selected
*      Allows for dependencies on at least one item being selected
* - noneSelectedFn: function to call when removing item if no items selected
*      Allows for dependencies on no items being selected
* - selectedFn: function to apply to selected item html string before rendering
*      Allows for pre-prending and post-pending html to item
* - selectTrigger: jQuery container for trigger that selects items
*      if selectTrigger is undefined, then just hitting "enter" on highlighted item or on input box will select it
* - selectOnEnter: boolean indicates whether item is selected when "Enter" key is pressed
*      Defaults to TRUE
* - selectOnAutocomplete: boolean indicates whether item is selected when autocomplete item is selected
*      Defaults to FALSE
* - selectOnBlur: boolean indicates whether item is selected when field loses focus (blurs)
*      Defaults to TRUE
* - selectInput : boolean indicates whether item in inputfield is also saved when selected items retrieved
*      Defaults to TRUE
* - restrictToAvailable: boolean indicates whether only available items can be selected
*      Defaults to TRUE, UNLESS availableItems is empty
* - restrictToUnique: boolean indicates whether each selected item must be unique
*      Defaults to TRUE
* - restrictMatchStart: boolean indicates whether autocomplete restricted to matches at beginning of word
*      Corresponds to 'matchContains = False' in autocomplete widget
*      Defaults to FALSE
* - minChars: minChars settings for autocomplete opts
* - inputId: id to attach to input field. Default is "acmsInputField"
* - inputClasses: array of classes to apply to input field.
*      Defaults to "field"
*      Always includes 'acmsInput'
* - inputSize: size of input box
* - readOnly: boolean indicates whether widget is read only, so that
*      no input box is added, so new items can be added
*      no existing items can be edited
*      no existing items can be deleted
* - removeTriggerText: text to display as remove button text.
*      Defaults to 'X'
* - removeTriggerClasses: array of classes to apply to remove trigger.
*      Defaults to "fieldActionButton"
* - removeFn: function to apply to item id when item removed
* - removeHtmlPlaceAfter : true if removeTrigger html should be placed after selected item html, rather than before
*      Defaults to false
* - noneText: custom text to display if no items listed. If '' (empty string), then no text displayed.
*      Default is 'None'.
* - noneClasses: array of classes to apply to noneText. Defaults to empty set.
* - infoText: custom text to display as information in input field on blur (see InfoFieldWidget)
* - infoClasses: array of clases to apply to input field when information is displaying (on blur)
* - noInputField: boolean indicates whether no input box should be added so that widget cannot be edited
* - editable: boolean indicates whether selected items are editable
*   * Default is FALSE.
* - editableWidth: in case width of default domElt is too small, gives a minimum width (important when widget hasn't yet been attached to DOM
*   and items are added)
*   * Default is 100
* - editableType: either "text" or "textarea"
*   * Default is "text"
* - editableRows: if type is "textarea", number of rows
*   * Default is 'auto'
* - editableCols: if type is "textarea", number of columns
*   * Default is 'auto'
* - editableSubmit: name of 'submit' button.
*   * Default is "Add"
*   * After submitting, focus returns to last field
* - additionalTriggers: array of additional triggers, of form [ { name : name1, fn : fn1, classes : [class1, class2,...] }, { name : name2, fn : fn2, classes: [class1, class2, ... ] } ]
*   * If no classes specified, default is 'actionSmall'
//
* RETURNS object with following public properties:
* - getSelectedItemsArray: array of all selected items
*      Returns [] if empty
* - getSelectedItemsIdArray: array of selected items in format [ {'id': id1, 'value': value1}, {'id': id2, 'value': value2}, ... ]
*      'id' returns either 'id' from original availableItems array, 'id' from public selectItem() call, or widget-assigned 'id'
* - getSelectedItemsPureIdArray: array of selected items in format [ {'id': id1, 'value': value1}, {'id': id2, 'value': value2}, ... ]
*      'id' is set as null if it is widget assigned (i.e. begins with 'w')
* - getSelectedIdsArray: array of selected item ids in format [ id1, id2, ... ]
*      'id' is set as null if it is widget assigned (i.e. begins with 'w')
* - getSelectedItem: takes id as input and returns value from selectedItemsSet
* - selectItem: appends selected item to end of selected container
* - doSelect: checks for item to be valid and then calls selectItem, as well as shifts focus to input field
* - isNoneSelected: Boolean indicating whether any items selected
* - inputField: InfoFieldWidget field; returns null if infoText is null
*      Does not allow selection of duplicate entries
*      Displays "None" (or noneText as defined below) if no entries are selected
* DEPENDENCIES:
*   - Page must include a div with id="alert-ui" (i.e. {% include 'dialog-alert.html' %})
*/

goog.provide('el8.uiwidget.acms');

goog.require('el8.util.consts');
goog.require('el8.service.intervals');
goog.require('el8.uiwidget.alert');
goog.require('el8.service.infoField');


el8.uiwidget.acms = function( options ) {

    var that = this;
    var readOnly = ( options.readOnly === true ); // defaults to false

    // ------------------------------
    // INPUT FIELD SETTINGS
    // ------------------------------
    var inputContainer = options.inputContainer;
    var inputId = options.inputId || "acmsInputField";
    var inputClasses = options.inputClasses || [ 'field' ];
    inputClasses.push('acmsInput'); // always include 'acmsInput' class
    var inputSize = options.inputSize || null;
    var inputMaxLength = options.inputMaxLength || 200;

    // Information to display in input field when field is empty and not in focus
    var hasInfoText = options.infoText ? true : false;
    var infoText = options.infoText || '';

    // ------------------------------
    // SELECT FIELD SETTINGS
    // ------------------------------
    var selectedContainer = options.selectedContainer;
    var selectTrigger = options.selectTrigger || false;
    var selectFn = options.selectFn || null;
    var selectSaveFn = options.selectSaveFn || null;
    var selectAltSaveFn = options.selectAltSaveFn || null;
    var hasSelectedFn = options.hasSelectedFn || null;
    var noneSelectedFn = options.noneSelectedFn || null;
    var selectedFn = options.selectedFn || function(a){ return a ? a.el8_escape() : ''; };
    var selectedContainerClasses = options.selectedContainerClasses || [ 'fieldSaved' ];

    // What displays when nothing is selected
    var noneText = options.noneText || (options.noneText === '') ? '' : 'None';
    var noneClasses = options.noneClasses || [];

    // ------------------------------
    // ITEMS AVAILABLE FOR SELECTION SETTINGS
    // ------------------------------
    var availableItems = options.availableItems || [];
    var hasId = options.availableItemsHasId || false;

    // Function takes selected string as input and returns True or False,
    // determining whether "Enter" from autocomplete should auto-select the term
    var autocompleteSelectFn = options.autocompleteSelectFn || function() { return false; };

    // If restrictToAvailable specified as false or no available items listed, then set as false; else, default is true.
    var restrictToAvailable = ( options.restrictToAvailable === false || availableItems.length === 0 ) ? false : true;

    // restrictToUnique defaults to true
    var restrictToUnique = ( options.restrictToUnique === false ) ? false : true;

    // ------------------------------
    // SELECTED ITEM SETTINGS
    // ------------------------------
    var selectedClasses = options.selectedClasses || [ 'fieldSavedList' ];
    var selectedIdPrefix = "select_";
    var selectOnEnter = ( options.selectOnEnter !== false ); // default is true
    var selectOnAutocomplete = (options.selectOnAutocomplete !== false); // default is true
    var selectOnBlur = ( options.selectOnBlur !==  false ); // default is true (still not sure about this feature; trying out...)
    var selectInput = ( options.selectInput !== false ); // default is true

    // Set tags for selected items
    var selectedAreaTag = ''; // Indicates selected items are NOT displayed as list
    var selectedTag = 'div';
    if( options.selectedListType === 'ordered' ) {
        selectedAreaTag = 'ol';
        selectedTag = 'li';
    } else if( options.selectedListType === 'unordered' ) {
        selectedAreaTag = 'ul';
        selectedTag = 'li';
    }

    // Initialize "listClasses" (applied when selected items displayed as list)
    var listClasses = options.listClasses || [ 'fieldSavedBullet' ];

    // Initialize whether selected item is editable and type of editable area
    var editable = readOnly ? false : (options.editable || false);  // false if readOnly

    // ------------------------------
    // REMOVE TRIGGER SETTINGS
    // ------------------------------
    var removeTriggerClasses = options.removeTriggerClasses || [ 'fieldActionButton' ];
    var removeTriggerPrefix = "remove_";
    var removeTriggerText = options.removeTriggerText || (options.removeTriggerText.trim() === '') ? '' : "X";
    var removeFn = options.removeFn || null;
    var removeHtmlPlaceAfter = ( options.removeHtmlPlaceAfter === true ) ? true : false;

    // ------------------------------
    // ADDITIONAL TRIGGER SETTINGS
    // ------------------------------
    var additionalTriggers = options.additionalTriggers || null;

    // ------------------------------
    // USEFUL DEFINITION AND METHODS
    // * selectedItemsSet: Holds all currently selected items
    // * counter: Helps assign unique id's to each selected item
    // ------------------------------
    var selectedItemsSet = {}; // 'id' --> 'item'
    function isNoneSelected() {
        if( selectInput ) {
            var itemValue = inputField ? inputField.getVal() : inputContainer.find('#' + inputId).val();
            if( itemValue !== '' ) {
                return false;
            }
        }
        for( var curr in selectedItemsSet ) {
            if( selectedItemsSet[ curr ] ) { return false; }
        }
        return true;
    }
    // ** MAKE PUBLICLY AVAILABLE **
    that.isNoneSelected = isNoneSelected;

    // Determines wheter item with given id has already been selected
    function isIdSelected( id ) {
        return ( selectedItemsSet[ id ] !== undefined );
    }
    // ** MAKE PUBLICLY AVAILABLE **
    that.isIdSelected = isIdSelected;

    function getSelectedItemsArray() {
        var result = [];
        for( var curr in selectedItemsSet ) {
           if( selectedItemsSet[ curr ] ) {
               result.push( selectedItemsSet[ curr ] );
            }
        }
        if( selectInput ) {
            var itemValue = inputField ? inputField.getVal() : inputContainer.find('#' + inputId).val();
            if( isPermittedItem( itemValue ).result ) {
                result.push( itemValue );
            }
        }
        return result;
    }
    // ** MAKE PUBLICLY AVAILABLE **
    that.getSelectedItemsArray = getSelectedItemsArray;

    function getSelectedItemsIdArray() {
        var result = [];
        for( var curr in selectedItemsSet ) {
            if (selectedItemsSet.hasOwnProperty(curr)) {
                result.push( { 'id' : curr, 'value' : selectedItemsSet[curr] } );
            }
        }
        if( selectInput ) {
            var itemValue = inputField ? inputField.getVal() : inputContainer.find('#' + inputId).val();
            if( isPermittedItem( itemValue ).result ) { // Give id with prefix 'w' (logic used externally)
                result.push( { 'id' : 'w', 'value' :  itemValue } );
            }
        }
        return result;
    }
    // ** MAKE PUBLICLY AVAILABLE **
    that.getSelectedItemsIdArray = getSelectedItemsIdArray;

    function getSelectedItemsPureIdArray() {
        var result = [];
        for( var curr in selectedItemsSet ) {
            if (selectedItemsSet.hasOwnProperty(curr)) {
                var id = ( curr[0] === 'w' ) ? null : curr;
                result.push( { 'id' : id, 'value' : selectedItemsSet[curr] } );
            }
        }
        if( selectInput ) {
            var itemValue = inputField ? inputField.getVal() : inputContainer.find('#' + inputId).val();
            if( isPermittedItem( itemValue ).result ) {
                result.push( { 'id' : null, 'value' :  itemValue } );
            }
        }
        return result;
    }
    // ** MAKE PUBLICLY AVAILABLE **
    that.getSelectedItemsPureIdArray = getSelectedItemsPureIdArray;

    function getSelectedIdsArray() {
        return getSelectedItemsPureIdArray().map( function(a) { return parseInt(a.id, 10); } );
    }
    // ** MAKE PUBLICLY AVAILABLE **
    that.getSelectedIdsArray = getSelectedIdsArray;

    function getSelectedItem( id ) {
        return selectedItemsSet[id];
    }
    // ** MAKE PUBLICLY AVAILABLE **
    that.getSelectedItem = getSelectedItem;

    function clearSelectedItems() {
        // Reset selectedItemsSet
        selectedItemsSet = {};

        // Reset selectedContainer
        initSelectedContainer();
    }
    // ** MAKE PUBLICLY AVAILABLE **
    that.clearSelectedItems = clearSelectedItems;

    // Convenient counter for assigning custom id's to new items
    var counter = 1;

    // ------------------------------
    // BEGIN PROCESSING
    // ------------------------------

    // General use
    var autocompleteFormatResult = options.autocompleteFormatResult || null;
    var autocompleteFormatSelected = options.autocompleteFormatSelected || null;

    // ------------------------------
    // INITIALIZE INPUT CONTAINER
    // ------------------------------
    var inputField = null;

    if( !readOnly ) {
        inputContainer.empty();
        inputContainer.append('<input type="text" autocomplete="off" maxlength="' + inputMaxLength + '" />'); // XSS OK -KF
        if( inputSize ) {
            inputContainer.find('input').attr({ id: inputId, size: inputSize });
        } else {
            inputContainer.find('input').attr({ id : inputId });
        }

        // Add classes
        for( var i=0; i<inputClasses.length; i++ ) {
            inputContainer.find('input').addClass( inputClasses[i] );
        }

        if( hasInfoText ) {
            inputField = el8.service.infoField.addInfoField({
                field : inputContainer.find('input'),
                infoText : infoText
            });
        }
        if( selectOnBlur ) {
            inputContainer.find('#' + inputId).blur( function() {
                if( inputContainer.find('#' + inputId).val() !== '' ) {
                    doSelect();
                }
            });
        }

    }

    // ** MAKE PUBLICLY AVAILABLE **
    that.inputField = inputField;

    // ------------------------------
    // INITIALIZE INPUT AUTOCOMPLETE AND ACTIVATE SELECTION TRIGGERS
    // ------------------------------
    var autocompleteSelected = false; // helps manage "enter" key when used within autocomplete not to also select the item
    function setAutocompleteItems(items) {availableItems = items;}
    function initAutocomplete() {
        // If availableItems or autocompleteURL, then set up autocomplete
        // (clicking or "enter"  on items in list will activate selection)
        if (availableItems.length > 0) {

            (new el8.uiwidget.LegacyMindreader({
                data: availableItems,
                limit: 100, // no limit essentially
                entryHeight: 25,
                formatResult : autocompleteFormatResult,
                formatSelected : autocompleteFormatSelected,
                rowToStringFn : autocompleteFormatSelected,
                selectFn : function(event, item) {
                    event.preventDefault();
                    event.stopPropagation();
                    autocompleteSelected = true;
                    if (selectOnAutocomplete) {
                        doSelect(item);
                    }
                }
            }).init(inputField.getInputField()));

        }
    }
    initAutocomplete();

    that.setAutocompleteItems = setAutocompleteItems;
    that.initAutocomplete = initAutocomplete;

    // If select trigger exists, activate trigger
    if( selectTrigger ) {
        selectTrigger.unbind('click').on('click', function( event ) {
            event.preventDefault();
            doSelect();
            // Return focus to input field
            inputContainer.find('input').focus();

        });
    }

    if( selectOnEnter ) {
        // Hitting "Enter" key selects inputted text
        inputContainer.find('input').on( 'keydown', function(e) {
            var evt = e || window.event;
            var keyPressed = evt.which || evt.keyCode;
            if( keyPressed === 13 && (!autocompleteSelected ||
                    autocompleteSelectFn($(this).val())) ) {  // If ENTER key is pushed not from autocomplete
                doSelect();
                inputContainer.find('input').focus();
            }
            autocompleteSelected = false; // reset autocomplete
        });
    }

    // ------------------------------
    // INITIALIZE SELECTED CONTAINER
    // ------------------------------
    function initSelectedContainer() {
        selectedContainer.empty();
        if( selectedAreaTag !== '' ) {
            // Selected items are NOT displayed as list
            selectedContainer.append( '<' + selectedAreaTag + ' style="display:none" class="' + allClasses( listClasses ) + '"></' + selectedAreaTag + '>' ); // XSS OK -KF
        }
        if( isNoneSelected() ) {
            for( var i=0; i<selectedContainerClasses.length; i++ ) {
                selectedContainer.removeClass( selectedContainerClasses[i] );
            }
        }

        // Display noneText if desired
        if( noneText !== '' ) {
            // We want to display text when no items are selected
            var noneHtml = renderSelectedItem( noneText, 'none', null, true );
            if( selectedAreaTag !== '' ) {
                selectedContainer.find( selectedAreaTag ).show().append( noneHtml );
            } else {
                selectedContainer.append( noneHtml );
            }
            for( var i=0; i<noneClasses.length; i++ ) {
                selectedContainer.find( '#' + getSelectedName('none') ).addClass( noneClasses[i] );
            }
        }
    }
    initSelectedContainer();

    // ------------------------------
    // MAIN FUNCTIONS: doSelect( item ) and selectItem( item )
    // ------------------------------

    function getAvailableItem( name ) {
        if (!(name)) {
            return false;
        } else if (options.getItemFn) {
            return options.getItemFn(name);
        } else {
            for (var i=0; i<availableItems.length; i++) {
                if (availableItems[i].value === name) {
                    return availableItems[i];
                }
            }
        }
        return false;
    }

    // Process the selection of a single item, breaking it down and testing
    // its permissiveness, then do the selecting
    function doSelectOne(itemValue, itemToAdd) {

        // Make sure itemValue is permissible, then call selectItem and clear inputContainer
        var permitted = isPermittedItem(itemValue);
        if( permitted.result ) {
            selectItem( itemToAdd );
            return true;

        // Else, desired behavior is to do nothing
        } else {
            if (permitted.msg) {
                el8.uiwidget.alert( permitted.msg, inputContainer.find('#' + inputId) );
            }
            return false;
        }
    }

    // Select the item and add it to the list
    // @item can be jQuery object (the item) or a list of jQuery objects
    function doSelect(item) {
        // Get the item to add
        var itemValue = null;
        if (!(item)) {
            itemValue = inputField ? inputField.getVal() : inputContainer.find('#' + inputId).val();
            item = itemValue ? getAvailableItem(itemValue) : false;
        }

        // If we have a list of items, select each individually
        if (item && item.length > -1) {
            var rejected = [];
            for (var i=0; i<item.length; i++) {
                if (isPermittedItem(item[i].value).result) {
                    selectItem(item[i]);
                } else {
                    rejected.push(item[i].value);
                }
            }

        // Otherwise, select the one
        } else if (item) {
            doSelectOne(item.value, item);

        // Or, if we're expecting an id, then fake one
        } else if (hasId) {
            doSelectOne(itemValue, {'id' : null, 'value' : itemValue});

        // Otherwise, just select the text
        } else {
            doSelectOne(itemValue, itemValue);
        }
    }

    // Handle the UI of selecting the item, appending it to the list and binding
    // buttons and actions
    function selectItem( item, doAltSave, doHighlight ) {

        if( inputContainer.find('#'+inputId).val() ) {
            inputField ? inputField.setVal('') : inputContainer.find('#'+inputId).val('');
        }
        var altSave = ( doAltSave === true );

        // Get itemValue and itemId
        var itemId;
        var itemValue = (item.value !== undefined) ? item.value : item;
        if( item.id ) {
            itemId = item.id;
        } else {
            itemId = 'w' + counter;
            counter ++;
        }

        // Check if additional removeFn specified
        var itemRemoveFn = item.removeFn || null;

        // Check if custom editableFn specified
        var editableFn = item.editableFn || null;

        // Collect all additional triggers to add (those specified originally as well as those specified by item argument)
        var itemAdditionalTriggers = additionalTriggers || null;
        itemAdditionalTriggers = item.additionalTriggers ? item.additionalTriggers.concat( itemAdditionalTriggers || [] ) : itemAdditionalTriggers;

        // Check if editable overwritten (default to true)
        var itemEditable = ( item.editable !== undefined ) ? (item.editable !== false) : editable;

        // Some items may want to suppress all additional triggers
        if( item.noAdditionalTriggers === true ) {
            itemAdditionalTriggers = null;
        }

        // Add to selectedItemsSet
        selectedItemsSet[ itemId ] = itemValue;

        if (selectFn) { selectFn(); }

        // Call selectSaveFn if exists and item doesn't already have id, and save new id if available
        if( selectSaveFn && !item.id && !altSave ) {
            var id = selectSaveFn( item );
            if( id ) {
                delete selectedItemsSet[ itemId ];
                selectedItemsSet[ id ] = itemValue;
            }
            itemId = id;
        // Call selectAltSaveFn is altSave is true
        } else if( selectAltSaveFn && !item.id && altSave ) {
            var id = selectAltSaveFn( item );
            if( id ) {
                delete selectedItemsSet[ itemId ];
                selectedItemsSet[ id ] = itemValue;
            }
            itemId = id;
        }

        // Apply UI rendering
        var addHtml = $(renderSelectedItem( itemValue, itemId, itemAdditionalTriggers ));
        if( selectedAreaTag !== '' ) {
            selectedContainer.find( selectedAreaTag ).show().append( addHtml );
        } else {
            selectedContainer.append( addHtml );
        }
        if (doHighlight) {
            addHtml.addClass('itemAdded');
            $.el8_setTimeout(function() { addHtml.removeClass('itemAdded'); }, 10000);
        }

        // Make sure that "noneText" is not displayed if not appropriate
        if( !isNoneSelected() ){
            selectedContainer.find('#' + selectedIdPrefix + 'none').hide();
            for( var i=0; i<selectedContainerClasses.length; i++ ) {
                selectedContainer.addClass( selectedContainerClasses[i] );
            }

            // Call hasSelectedFn if available
            if( hasSelectedFn ) {
                hasSelectedFn();
            }
        }

        if( itemEditable ) {

            var domElt = selectedContainer.find('#' + getSelectedName( itemId ));
            var elt = domElt.find('span.elt');

            if( editableFn ) {
                domElt.unbind('click').on('click', function(event) {
                    editableFn( elt );
                });

            }
        }

        // Activate triggers
        activateRemoveTrigger( itemId );
        if( itemAdditionalTriggers ) { activateAdditionalTriggers( itemId ); }

        // Helper function to activate a given remove trigger
        function activateRemoveTrigger( id ) {
            selectedContainer.find('#' + getRemoveTriggerName( id ) ).unbind('click').on('click', function(event) {
                event.preventDefault();
                event.stopPropagation();

                // Remove item from selectedItemsSet and from view
                selectedContainer.find('#' + getSelectedName( id ) ).remove();
                delete selectedItemsSet[ id ];

                // Display "noneText" (if applicable) if no items selected
                if( isNoneSelected() ) {
                    selectedContainer.find('#' + selectedIdPrefix + 'none').show();
                    for( var i=0; i<selectedContainerClasses.length; i++ ) {
                        selectedContainer.removeClass( selectedContainerClasses[i] );
                    }

                    // Call noneSelectedFn if available
                    if( noneSelectedFn ) {
                        noneSelectedFn();
                    }
                }

                // Apply removeFn
                if( removeFn ) {
                    removeFn( id );
                }

                // Apply itemRemoveFn
                if( itemRemoveFn ) {
                    itemRemoveFn();
                }

                // Apply focus back to input field
                inputContainer.find('#'+inputId).focus();

            });
            return;
        }

        // Helper function to activate additional triggers
        function activateAdditionalTriggers( id ) {
            for( var i=0; i<itemAdditionalTriggers.length; i++ ) {
                if( itemAdditionalTriggers[i].name ) {
                    var triggerName = itemAdditionalTriggers[i].name + "_" + id;
                    triggerName = triggerName.replace(/ /g, ''); // remove all spaces
                    var triggerFn = itemAdditionalTriggers[i].fn;
                    var onceOnly = itemAdditionalTriggers[i].onceOnly === true;

                    selectedContainer.find('#' + triggerName ).unbind('click').on('click', function(event) {
                        event.preventDefault();
                        event.stopPropagation();
                        if( triggerFn ) {
                            triggerFn( id, $(this) );
                        }
                        if( onceOnly ) {
                            selectedContainer.find('#' + triggerName ).remove();
                        }
                    });
                }
            }
            return;
        }

        return itemId;
    }

    // *** MAKE PUBLICLY AVAILABLE ** //
    that.doSelect = doSelect;
    that.selectItem = selectItem;

    // Helper function to see if itemValue is permitted
    // Check available, unique, and whether empty string
    function isAvailableItem( itemValue ) {
        return getAvailableItem(itemValue) ? true : false;
    }
    function isUniqueItem( itemValue ) {
        for( var curr in selectedItemsSet ) {
            if( selectedItemsSet[curr] === itemValue ) {return false;}
        }
        return true;
    }
    function isPermittedItem( itemValue ) {
        if (restrictToAvailable && !isAvailableItem(itemValue)) {
            return {result: false, msg: 'Please select from the available items.'};
        } else if (restrictToUnique && !isUniqueItem(itemValue)) {
            return {result: false, msg: 'Sorry but your input is a duplicate.'};
        } else if (itemValue === '') {
            return {result: false, msg: null};
        } else if (itemValue.toLowerCase().endswith('(order set)')) {
            return {result: false, msg: 'Sorry but you cannot use the phrase "(order set)" in your input'};
        }
        return {result: true};
    }

    // ------------------------------
    // SECONDARY HELPER FUNCTIONS
    // ------------------------------
    function renderSelectedItem( item, id, additionalTriggers, noRemove ) {

        if( readOnly ) { noRemove = true; } // Force no remove button if readOnly

        // Apply selectedFn here
        var html = '<' + selectedTag + ' class="' + allClasses( selectedClasses ) + '" id="' + getSelectedName( id ) + '">';

        if( !noRemove && !removeHtmlPlaceAfter ) {
            html += '<a href="#" class="' + allClasses( removeTriggerClasses ) + '" id="' + getRemoveTriggerName( id ) + '">' + removeTriggerText + '</a>';
        }

        html += '<span class="elt">' + selectedFn( item ) + '</span>';

        if( !noRemove && removeHtmlPlaceAfter ) {
            html += '<a href="#" class="' + allClasses( removeTriggerClasses ) + '" id="' + getRemoveTriggerName( id ) + '">' + removeTriggerText + '</a>';
        }

        if( additionalTriggers ) {
            for( var i=0; i<additionalTriggers.length; i++ ) {
                // Only add if additional triggers item is well-formed
                if( additionalTriggers[i].name ) {
                    var triggerClasses = additionalTriggers[i].classes ||  [ 'actionSmall' ];
                    var triggerName = additionalTriggers[i].name + "_" + id;
                    triggerName = triggerName.replace(/ /g,"");
                    var triggerText = additionalTriggers[i].name;
                    html += '<a href="#" class="' + allClasses( triggerClasses ) + '" id="' + triggerName + '">' + triggerText + '</a>';
                }
            }
        }

        html += '</' + selectedTag + '>';
        return html;
    }

    function allClasses( classesArray ) {
        return (classesArray.length > 0) ? classesArray.join(' ') : '';
    }

    function getRemoveTriggerName( id ) {
        return removeTriggerPrefix + id;
    }
    function getSelectedName( id ) {
        return selectedIdPrefix + id;
    }

    return that;
};
